export default "__VITE_ASSET__C_eM00hl__"